module.exports = __webpack_public_path__ + "media/general-notif.902e6a0b.wav";